import React from "react";
import { Button, Result, Space, Typography } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import { trackException } from "../observability/telemetry";

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    trackException(error, {
      source: "react.error_boundary",
      componentStack: errorInfo?.componentStack || "",
    });
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 24 }}>
          <Result
            status="error"
            title="Something went wrong"
            subTitle="The admin portal hit an unexpected error. You can reload the page and try again."
            extra={
              <Space direction="vertical" size={12}>
                <Button type="primary" icon={<ReloadOutlined />} onClick={this.handleReload}>
                  Reload
                </Button>
                {this.state.error ? (
                  <Typography.Text type="secondary" style={{ maxWidth: 520, display: "block" }}>
                    {this.state.error.message}
                  </Typography.Text>
                ) : null}
              </Space>
            }
          />
        </div>
      );
    }

    return this.props.children;
  }
}

export default AppErrorBoundary;
